import Reveal from '@/components/base/Reveal';
import CtaLink from '@/pages/home/components/CtaLink';

export default function EngagementTypes() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            How We Work
          </span>
          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            Two Ways to Create Better Results
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* DFY */}
          <Reveal>
            <div className="h-full rounded-2xl border border-white/10 bg-gradient-to-b from-background-200 to-background-100 p-8 md:p-10">
              <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/15 text-primary-400 px-3 py-1 text-xs font-label font-semibold">
                <i className="ri-rocket-line"></i>
                Done For You
              </span>
              <h3 className="mt-6 font-heading font-bold text-2xl text-foreground-950">
                DFY Marketing
              </h3>
              <p className="mt-3 text-foreground-600 leading-relaxed">
                Josh and the team help execute and optimize the marketing
                systems end to end.
              </p>
              <ul className="mt-6 flex flex-wrap gap-2">
                {[
                  'Strategy',
                  'Implementation',
                  'Management',
                  'Optimization',
                  'Reporting',
                ].map((f) => (
                  <span
                    key={f}
                    className="rounded-full bg-background-300/40 text-foreground-700 px-3 py-1 text-xs font-label font-medium">
                    {f}
                  </span>
                ))}
              </ul>
              <div className="mt-8">
                <CtaLink href="/#work-with-josh" className="w-full">
                  Explore DFY Marketing
                </CtaLink>
              </div>
            </div>
          </Reveal>

          {/* DWY */}
          <Reveal delay={120}>
            <div className="h-full rounded-2xl border border-primary-500/30 bg-background-100 p-8 md:p-10">
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/15 text-accent-400 px-3 py-1 text-xs font-label font-semibold">
                <i className="ri-compass-3-line"></i>
                Done With You
              </span>
              <h3 className="mt-6 font-heading font-bold text-2xl text-foreground-950">
                DWY Consulting
              </h3>
              <p className="mt-3 text-foreground-600 leading-relaxed">
                Josh works alongside your existing team to guide strategy and
                optimization.
              </p>
              <ul className="mt-6 flex flex-wrap gap-2">
                {[
                  'Strategic direction',
                  'Marketing audits',
                  'Team guidance',
                  'Accountability',
                  'Performance review',
                ].map((f) => (
                  <span
                    key={f}
                    className="rounded-full bg-background-300/40 text-foreground-700 px-3 py-1 text-xs font-label font-medium">
                    {f}
                  </span>
                ))}
              </ul>
              <div className="mt-8">
                <CtaLink
                  href="/#work-with-josh"
                  variant="secondary"
                  className="w-full">
                  Explore DWY Consulting
                </CtaLink>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={200}>
          <p className="mt-8 text-center text-sm text-foreground-600">
            Not sure which model fits your business? Apply and we&rsquo;ll
            determine the best approach.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
